import React from "react"
import styled from "styled-components"

import ContentWrapper from "styles/contentWrapper"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.solitudeDark};
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`


const StyledCardsWrapper = styled.div`
  min-height: 19rem;
  margin-top: -4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: -4rem;

  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    margin-top: ${props => props.videoUrl ? "-16rem" : "-4rem"};
  }
`

const Grid = ({ children, videoUrl }) => {
  return (
    <StyledSection  id="grid">
      <StyledContentWrapper>
        <StyledCardsWrapper videoUrl={videoUrl}>
          {children}
        </StyledCardsWrapper>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default Grid
